import styled from "styled-components";
import { ButtonSettings } from "../../../services/visualLibraryService";
import { i18n } from "../../../services/i18nService";

export const ButtonStyled = styled(ButtonSettings)`
  ${props =>
    props.displayBlock &&
    `
    display: block;
    margin: auto;
    margin-top: ${props.theme.spacing.medium};
    width: 35rem;
  `}
`;

export const LogoStyled = styled.div`
  margin-bottom: 0.67em;
  ${props => `text-align: ${props.theme.locale.dir === i18n.directions.RIGHT_TO_LEFT ? "left" : "right"}`};
`;
